export default {
  IdNumber: 'national_ID',
  password: 'password',
  newPassword: 'new password',
  passwordChecked: 'confirm password',
  currentPassword: 'current password',
  changePassword: 'change password',
  phoneNumber: 'phone number',
  userName: 'user name',
  fullName: 'Full name',
  email: 'E-mail address',
  address: 'address',
  otbCode: 'Code',
  countryCode: 'country code',
  check: 'check',
  enter: 'submit',
  enterAccount: 'Login',
  createNewAccount: ' Sign up',
  createAccount: ' Create account',
  codeOtb: 'OTP Code',
  otbTitle: 'A message has been sent to your mobile number',
  otbInfo: 'Include the OTB symbol',
  continueOtb: 'Continue',
  create: 'Create',
  logIn: 'sign in ',
  logout: 'sign out',
  forgetPassword: 'forget password ?',
  send: 'send',
  connectWith: 'Connect with us',
  messageText: 'Message Text',
  save: 'save',
  userInformation: 'User Information',
  change: 'change',
  resetPassword: 'Reset your password',
  verifyResetPassword: 'Please enter reset password token',
  resetPasswordContent: 'For reset your password we will send you a code to your phone number to reset the password',
  aboutUs: 'about us',
  secondary_phone_number: 'secondary phone number'
}
